export const rePossibleCharacteristicConstants = {
	GetList: {
		REQUEST : 'GET_LIST_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_LIST_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'GET_LIST_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	GetPaged: {
		REQUEST : 'GET_PAGED_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_PAGED_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'GET_PAGED_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	GetPagedAudit: {
		REQUEST : 'GET_PAGED_AUDIT_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_PAGED_AUDIT_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'GET_PAGED_AUDIT_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'CREATE_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'CREATE_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'DELETE_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'DELETE_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'UPDATE_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'UPDATE_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_POSSIBLE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'RESTORE_POSSIBLE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'RESTORE_POSSIBLE_CHARACTERISTIC_FAILURE'
	},
	CLEAR: 'CLEAR_POSSIBLE_CHARACTERISTIC'
}